import React, { Component } from "react";

// App imports.
import DbSelectListByCode from "../../BaseComponents/DbSelectListByCode"
import RadioYesNoAll from "../../BaseComponents/RadioYesNoAll"
import { IndexRadioOptionsEnum } from "../utility";
import * as worker from "../../baseWorker";


const BenefitTargetingComp4 = ({ state }) => (
  <div >
    <h2>{state.SelectedIndexHistory.SelectedIndexString}  Index  – Customizing Your Comparison</h2>
    <br /><br />
    <p>Now you know more about how your own  {state.SelectedIndexHistory.SelectedIndexString}    performance measures compare to other grantees.&nbsp; Here is the option to take a deeper dive.</p>
    <p>Below, you may select which states you would like to include in the custom comparison with your own state. You can filter the states included in the comparison by Index Value or by selecting a particular region or custom grouping of states, or some combination of all of those factors.</p>
    <p>Once you have selected your filter criteria, you can choose the information you would like to be displayed in the table for each state in your filtered search. After you&rsquo;ve made your selection(s), please click <em>Next</em> to continue. (Note: You will have the opportunity to change your selection once you have viewed your results).&nbsp;</p>

    <div className="takeaways"><h3>Filter States</h3></div>
    <div className="takeaways">
      <div className="row">
        <div className="col-sm-6">
          <strong>{state.SelectedIndexHistory.SelectedIndexString}  Index Value</strong><br />
          I want to see information on states with a {state.SelectedIndexHistory.SelectedIndexString}  Index value:<br />
          <label>
            <input type="radio"
              name="rdoIndexValOperator"
              id="rdoIndexValOperatorAll"
              value={IndexRadioOptionsEnum.All}
              checked={state.selectedIndexValOperator === IndexRadioOptionsEnum.All}
              onChange={state.benTargetingComp4ClickHandler}
            />
            <span>All</span>
          </label><br />
          <label>
            <input type="radio"
              name="rdoIndexValOperator"
              id="rdoIndexValOperatorGreaterThan"
              value={IndexRadioOptionsEnum.GreaterThan}
              checked={state.selectedIndexValOperator === IndexRadioOptionsEnum.GreaterThan}
              onChange={state.benTargetingComp4ClickHandler}
            />
            <span>Greater than: </span>
            {state.selectedIndexValOperator === IndexRadioOptionsEnum.GreaterThan
              &&
              <input name="txtIndexVal"
                id="txtIndexVal"
                value={state.enteredIndexVal}
                onChange={state.benTargetingComp4InputHandler}
              />
            }
          </label><br />
          <label>
            <input type="radio"
              name="rdoIndexValOperator"
              id="rdoIndexValOperatorLessThan"
              value={IndexRadioOptionsEnum.LessThan}
              checked={state.selectedIndexValOperator === IndexRadioOptionsEnum.LessThan}
              onChange={state.benTargetingComp4ClickHandler}
            />
            <span>Less than: </span>
            {state.selectedIndexValOperator === IndexRadioOptionsEnum.LessThan
              &&
              <input name="txtIndexVal"
                id="txtIndexVal"
                value={state.enteredIndexVal}
                onChange={state.benTargetingComp4InputHandler}
              />
            }
          </label><br />
          <label>
            <input type="radio"
              name="rdoIndexValOperator"
              id="rdoIndexValOperatorEqualTo"
              value={IndexRadioOptionsEnum.EqualTo}
              checked={state.selectedIndexValOperator === IndexRadioOptionsEnum.EqualTo}
              onChange={state.benTargetingComp4ClickHandler}
            />
            <span>Equal to:</span>
            {state.selectedIndexValOperator === IndexRadioOptionsEnum.EqualTo
              &&
              <input name="txtIndexVal"
                id="txtIndexVal"
                value={state.enteredIndexVal}
                onChange={state.benTargetingComp4InputHandler}
              />
            }
          </label><br />
          <label>
            <input type="radio"
              name="rdoIndexValOperator"
              id="rdoIndexValOperatorBetween"
              value={IndexRadioOptionsEnum.Between}
              checked={state.selectedIndexValOperator === IndexRadioOptionsEnum.Between}
              onChange={state.benTargetingComp4ClickHandler}
            />
            <span>Between:</span>
            {state.selectedIndexValOperator === IndexRadioOptionsEnum.Between
              &&
              <React.Fragment>
                <input name="txtIndexVal"
                  id="txtIndexVal"
                  value={state.enteredIndexVal}
                  onChange={state.benTargetingComp4InputHandler}
                />
                and
                <input name="txtIndexValUpperBound"
                  id="txtIndexValUpperBound"
                  value={state.enteredIndexValUpperBound}
                  onChange={state.benTargetingComp4InputHandler}
                />
              </React.Fragment>
            }
          </label><br />
        </div>

        <div className="col-sm-6">
          <strong>Select States</strong>
          <br />
          Select Region:
          <select className="form-control"
            onChange={clickEvent => state.burdenReductionFilterHandler('SelectedRegionId', clickEvent.target.value)}
            defaultValue={state.SelectedRegionId}>
            <option value="">Select a Region</option>
            {state.Regions.map(r => {
              return (
                <option key={r.regionId} value={r.regionId}>{r.regionName}</option>
              );
            })}
          </select>
          <br />
          <br />
          Select States:
          <select className="form-control"
            defaultValue={state.SelectedGranteeArray}
            onChange={clickEvent => state.burdenReductionFilterHandler('SelectedGrantees', clickEvent.target.selectedOptions)}
            multiple={true}
            style={{ "height": "150px" }}>
            <option value="">Select a State</option>
            {state.Grantees.map(g => {
              return (
                <option selected={state.SelectedGranteeArray.includes(g.granteeId)}
                  key={g.granteeId}
                  value={g.granteeId}>{g.granteeName}</option>
              );
            })}
          </select>
        </div>
      </div>
    </div>


    <div className="takeaways"><h3>Choose Characteristics Included in the Report: </h3></div>
    <div className="takeaways">

      Click on the checkboxes next to the information that you want to include in the table.
      You can select more than one to display the information side by side.
      After you are done, click "Next" to move on to the next screen.
      <br /><br />
      <div className="row">
        <div className="col-sm-4">
          <strong>General Information</strong><br />
          <label htmlFor="includeContact" onChange={e => state.benTargetingComp4Clicked("includeContact", e)}
              >
            <input 
              type="checkbox"
              name="includeContact"
              id='includeContact'
              checked={!!state.includeContact}
            />
            Contact Information
          </label><br />
          <label htmlFor="includeGranteeProfiles" onChange={e => state.benTargetingComp4Clicked("includeGranteeProfiles", e)}>
            <input
              type="checkbox"
              name="includeGranteeProfiles"
              id='includeGranteeProfiles'
              checked={!!state.includeGranteeProfiles}
            />
            Grant Recipient Profiles
          </label><br />
        </div>
        <div className="col-sm-4">
          <strong>Program Components</strong><br />
          <label htmlFor="includeCooling" onChange={e => state.benTargetingComp4Clicked("includeCooling", e)}
          >
            <input
              type="checkbox"
              name="includeCooling"
              id='includeCooling'
              checked={!!state.includeCooling}
            />
            Cooling Program Description
          </label><br />
          <label htmlFor="includeWzDescription" onChange={e => state.benTargetingComp4Clicked("includeWzDescription", e)}>
            <input
              type="checkbox"
              name="includeWzDescription"
              id='includeWzDescription'
              checked={!!state.includeWzDescription}
            />
            Weatherization Program Description
          </label><br />
          <label htmlFor="includeAssurance16" onChange={e => state.benTargetingComp4Clicked("includeAssurance16", e)}>
            <input
              type="checkbox"
              name="includeAssurance16"
              id='includeAssurance16'
              checked={!!state.includeAssurance16}
            />
            Assurance 16 Program Description
          </label><br />
          <label htmlFor="includeNominalBenefits" onChange={e => state.benTargetingComp4Clicked("includeNominalBenefits", e)}>
            <input
              type="checkbox"
              name="includeNominalBenefits"
              id='includeNominalBenefits'
              checked={!!state.includeNominalBenefits}
            />
            Nominal Benefits (Heat and Eat)
          </label><br />
        </div>
        <div className="col-sm-4">
          <strong>Eligibility</strong><br />
          <label htmlFor="includeCrisis" onChange={e => state.benTargetingComp4Clicked("includeCrisis", e)}
          >
            <input
              type="checkbox"
              name="includeCrisis"
              id='includeCrisis'
              checked={!!state.includeCrisis}
            />
            Crisis Definition
          </label><br />
          <label htmlFor="includeCategoricalEligibility" onChange={e => state.benTargetingComp4Clicked("includeCategoricalEligibility", e)}
          >
            <input
              type="checkbox"
              name="includeCategoricalEligibility"
              id='includeCategoricalEligibility'
              checked={!!state.includeCategoricalEligibility}
            />
            Categorical Eligibility Policies
          </label><br />
          <label htmlFor="includeIncomeThreshold" onChange={e => state.benTargetingComp4Clicked("includeIncomeThreshold", e)}
          >
            <input
              type="checkbox"
              name="includeIncomeThreshold"
              id='includeIncomeThreshold'
              checked={!!state.includeIncomeThreshold}
            />
            Income Threshold (Heating Assistance)
          </label><br />
          <label htmlFor="includeHousing" onChange={e => state.benTargetingComp4Clicked("includeHousing", e)}
          >
            <input
              type="checkbox"
              name="includeHousing"
              id='includeHousing'
              checked={!!state.includeHousing}
            />
            Subsidized Housing Policies
          </label><br />
        </div>
      </div>


      <div className="row">
        <div className="col-sm-4">
          <strong>Targeting</strong><br />
          <label htmlFor="includeBenefitMatrix" onChange={e => state.benTargetingComp4Clicked("includeBenefitMatrix", e)}
          >
            <input
              type="checkbox"
              name="includeBenefitMatrix"
              id='includeBenefitMatrix'
              checked={!!state.includeBenefitMatrix }
            />
            Benefit Matrix
          </label><br />
          <label htmlFor="includeCriteriaForVarying" onChange={e => state.benTargetingComp4Clicked("includeCriteriaForVarying", e)}
          >
            <input
              type="checkbox"
              name="includeCriteriaForVarying"
              id='includeCriteriaForVarying'
              checked={!!state.includeCriteriaForVarying}
            />
            Heating Assistance Criteria
          </label><br />
          <label htmlFor="includeBenefitLevels" onChange={e => state.benTargetingComp4Clicked("includeBenefitLevels", e)}
          >
            <input
              type="checkbox"
              name="includeBenefitLevels"
              id='includeBenefitLevels'
              checked={!!state.includeBenefitLevels}
            />
            Benefit Levels
          </label><br />
        </div>
        <div className="col-sm-4">
          <strong>Program Administration</strong><br />
          <label htmlFor="includeOutreach" onChange={e => state.benTargetingComp4Clicked("includeOutreach", e)}
          >
            <input
              type="checkbox"
              name="includeOutreach"
              id='includeOutreach'
              checked={!!state.includeOutreach}
            />
            Outreach Practices
          </label><br />
          <label htmlFor="includePercentageWeatherization" onChange={e => state.benTargetingComp4Clicked("includePercentageWeatherization", e)}
          >
            <input
              type="checkbox"
              name="includePercentageWeatherization"
              id='includePercentageWeatherization'
              checked={!!state.includePercentageWeatherization}
            />
            Percentage of Funds Obligated to Weatherization
          </label><br />
          <label htmlFor="includeIntakeOrganizationType" onChange={e => state.benTargetingComp4Clicked("includeIntakeOrganizationType", e)}
          >
            <input
              type="checkbox"
              name="includeIntakeOrganizationType"
              id='includeIntakeOrganizationType'
              checked={!!state.includeIntakeOrganizationType}
            />
            Type of Organization Performing Intake (Heating Assistance)
          </label><br />
        </div>
      </div>

    </div>


  </div>
);

export default BenefitTargetingComp4;
